import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-colors-card',
  templateUrl: './colors-card.component.html',
  styleUrls: ['./colors-card.component.scss']
})
export class ColorsCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
